/**
 * The sentence the server refused with.
 *
 * Every save on this app used to end `catch (e) { console.log(e) }`, so a
 * refusal the backend had written in plain English ("This section is not open
 * for editing at the current stage.") reached the user as nothing at all — a
 * Save button that did nothing when pressed. The rules the process engine
 * enforces are exactly the ones a person cannot guess from the screen, so the
 * server's own wording is the most useful thing we have.
 *
 * Shapes DRF actually returns: `detail` (PermissionDenied, NotFound, throttled),
 * `message` (this codebase's ValidationErrors), a bare string, or a dict of
 * field -> [errors] for a serializer failure.
 */
export const apiErrorMessage = (error: any, fallback: string): string => {
  const body = error?.body ?? error?.response?.data;

  const flatten = (value: any): string[] => {
    if (value === null || value === undefined) return [];
    if (typeof value === "string") return [value];
    if (Array.isArray(value)) return value.flatMap(flatten);
    if (typeof value === "object") return Object.values(value).flatMap(flatten);
    return [String(value)];
  };

  const primary = body?.message ?? body?.detail;
  const parts = primary !== undefined ? flatten(primary) : flatten(body);
  // `missing` is the list send-to-approval refuses with; keep it attached.
  const missing = Array.isArray(body?.missing) ? body.missing : [];

  const text = [...parts, ...missing].filter(Boolean).join(" ");
  return text || error?.message || fallback;
};
